export default __webpack_public_path__ + "static/media/event-icon.dc6c2b9c.svg";